module.exports = __webpack_public_path__ + "img/email_icon.7fd64f2a.png";